/**
 * [MC] A/B price-test — cross-region cart-attribute guard (sitewide)
 *
 * The price-test cart attribute carries a region:
 *   _ab_price_test = {"secret":"…","region":"AU"}
 * The Shopify Functions cart-transform prices from it, and the price test runs in
 * Australia only (the AUD market — the same rule b3g3-state and the header menus
 * use). So:
 *   - in AU it's kept only when tagged for AU ("AU" / "AUS"); untagged, or tagged
 *     for another region, it's wiped (the AU test always tags its attribute);
 *   - everywhere else it's always wiped, whatever its tag. The Shopify cart is
 *     shared across www./sg./hk./ph./eu. (cookie on .drwoofapparel.com), and a test
 *     price must not ride a cart out of Australia.
 *
 * One cart read per page; only POSTs when there's something to wipe. Origin:
 * Convert price-test workstream (SG / HK first, now AU only).
 */
(function () {
  'use strict';
  var ATTR = '_ab_price_test';

  // 'AU' in the Australian market (AUD), else null: no price test runs anywhere else.
  function regionNow() {
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return cur === 'AUD' ? 'AU' : null;
  }

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var raw = cart && cart.attributes && cart.attributes[ATTR];
      if (!raw) return;
      var region = null;
      try { region = (JSON.parse(raw) || {}).region || null; } catch (e) { region = null; }
      var ours = !!region && /^AUS?$/i.test(region); // tagged for AU
      if (regionNow() === 'AU' && ours) return;      // the test's own market → keep
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { _ab_price_test: '' } })
      });
    })
    .catch(function () {});
})();
